import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "as-final-score" }
const _hoisted_2 = { class: "as-final-score__head" }
const _hoisted_3 = { class: "as-final-score__body" }
const _hoisted_4 = { class: "as-result" }
const _hoisted_5 = { class: "as-scoreboard" }
const _hoisted_6 = { class: "as-match-item__vs as-t_vs_num" }
const _hoisted_7 = { class: "as-result__scores" }
const _hoisted_8 = {
  key: 0,
  class: "as-competition"
}
const _hoisted_9 = { class: "as-competition__table" }
const _hoisted_10 = { class: "as-center a" }
const _hoisted_11 = { class: "as-center a" }
const _hoisted_12 = { class: "as-statics-list" }

import type { IMatch } from "~src/interfaces";
import IconFinalScore from "~src/components/icons/foot_stats/IconFinalScore.vue";
import IncidentsList from "~src/components/foot_stats/final_score/IncidentsList.vue";
import StaticsItem from "~src/components/foot_stats/final_score/StaticsItem.vue";
import type { IFootyStats, IGoalDetails } from "~src/interfaces/footystats";
import { computed } from "vue";
import { getClassForItem } from "~src/helpers/footystats";

const __default__ = {};

interface Props {
  match: IMatch;
  footyStats: IFootyStats | null
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FinalScore',
  props: {
    match: {},
    footyStats: {}
  },
  setup(__props: any) {

const props = __props;

const goalDetails = computed<IGoalDetails[]>(() => {
  if (props.footyStats) {
    const { team_a_goal_details, team_b_goal_details } = props.footyStats;
    // Gộp thông tin bàn thắng
    const mergedGoals: IGoalDetails[] = [
      ...team_a_goal_details.map((goal: IGoalDetails) => ({
        ...goal,
        time: Number(goal.time),
        team: 'home'
      })),
      ...team_b_goal_details.map((goal: IGoalDetails) => ({
        ...goal,
        time: Number(goal.time),
        team: 'away'
      })),
    ]
      .sort((a: IGoalDetails, b: IGoalDetails) => a.time - b.time);

    let __home = 0;
    let __away = 0;

    // Tính điểm cho mỗi bàn thắng và gán điểm vào item
    const updatedGoals = mergedGoals.map((item: IGoalDetails) => {
      // Tăng số bàn thắng cho từng đội
      if (item.team === 'home') {
        __home += 1;
      }
      if (item.team === 'away') {
        __away += 1;
      }

      // Gán điểm vào item
      return {
        ...item,
        point: {
          home: __home,
          away: __away,
        },
      };
    });

    return updatedGoals;
  }

  return [];
});

const getValue = (key = '', is_none = false) => {
  const data = props.footyStats;
  if(data){
    let _val = data[key] ?? 0;

    if(key == 'a_card'){
      _val = data.team_a_yellow_cards + data.team_a_red_cards
    }

    if(key == 'b_card'){
      _val = data.team_b_yellow_cards + data.team_b_red_cards
    }

    if(_val < 0){
      return 'N/A'
    }

    return _val;
  }

  return 'N/A';
}

const showTable = () => {
  // console.log(getValue('team_a_possession'))
  // console.log(getValue('team_b_possession'))
  // console.log(getValue('team_a_shots'))
  // console.log(getValue('team_b_shots'))
  // console.log(getValue('a_card'))
  // console.log(getValue('b_card'))
  // console.log(getValue('team_a_corners'))
  // console.log(getValue('team_b_corners'))
  // console.log(getValue('team_a_fouls'))
  // console.log(getValue('team_b_fouls'))
  // console.log(getValue('team_a_offsides'))
  // console.log(getValue('team_b_offsides'))
  // console.log(getValue('team_a_xg'))
  // console.log(getValue('team_b_xg'))
  if(
    getValue('team_a_possession') === 'N/A'
    && getValue('team_b_possession') === 'N/A'
    && getValue('team_a_shots') === 'N/A'
    && getValue('team_b_shots') === 'N/A'
    && getValue('a_card') === 'N/A'
    && getValue('b_card') === 'N/A'
    && getValue('team_a_corners') === 'N/A'
    && getValue('team_b_corners') === 'N/A'
    && getValue('team_a_fouls') === 'N/A'
    && getValue('team_b_fouls') === 'N/A'
    && getValue('team_a_offsides') === 'N/A'
    && getValue('team_b_offsides') === 'N/A'
    && getValue('team_a_xg') === 'N/A'
    && getValue('team_b_xg') === 'N/A'
  ){
    return false;
  }
  return true
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(IconFinalScore),
      _cache[0] || (_cache[0] = _createElementVNode("span", null, " Điểm chung cuộc ", -1))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "as-div" }, null, -1)),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _createElementVNode("span", {
              class: _normalizeClass(["as-home-score", {
              'as-winner' : _ctx.footyStats && _ctx.footyStats?.homeGoalCount > _ctx.footyStats?.awayGoalCount
            }])
            }, _toDisplayString(_ctx.footyStats?.homeGoalCount), 3),
            _cache[1] || (_cache[1] = _createTextVNode(" : ")),
            _createElementVNode("span", {
              class: _normalizeClass(["as-away-score", {
              'as-winner' : _ctx.footyStats && _ctx.footyStats?.homeGoalCount < _ctx.footyStats?.awayGoalCount
            }])
            }, _toDisplayString(_ctx.footyStats?.awayGoalCount), 3)
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createTextVNode(" HT ")),
          _createElementVNode("span", null, _toDisplayString(`${_ctx.footyStats?.ht_goals_team_a ?? 0} - ${_ctx.footyStats?.ht_goals_team_b ?? 0}`), 1)
        ])
      ])
    ]),
    _createVNode(IncidentsList, {
      goalDetails: goalDetails.value,
      players: _ctx.footyStats?.list_players ?? []
    }, null, 8, ["goalDetails", "players"]),
    (showTable())
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("table", _hoisted_9, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("th", null, "Thi đấu", -1)),
                _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.footyStats?.home_name), 1),
                _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.footyStats?.away_name), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("td", null, "Kiểm soát bóng", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_possession'))}`)
                }, _toDisplayString(getValue('team_a_possession')) + "% ", 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_possession'))}`)
                }, _toDisplayString(getValue('team_b_possession')) + "% ", 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, "Cú sút", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_shots'))}`)
                }, _toDisplayString(getValue('team_a_shots')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_shots'))}`)
                }, _toDisplayString(getValue('team_b_shots')), 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[7] || (_cache[7] = _createElementVNode("td", null, "Thẻ", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_xg'))}`)
                }, _toDisplayString(getValue('a_card')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_xg'))}`)
                }, _toDisplayString(getValue('b_card')), 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, "Phạt góc", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_corners'))}`)
                }, _toDisplayString(getValue('team_a_corners')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_corners'))}`)
                }, _toDisplayString(getValue('team_b_corners')), 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[9] || (_cache[9] = _createElementVNode("td", null, "Phạm lỗi", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_fouls'))}`)
                }, _toDisplayString(getValue('team_a_fouls')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_fouls'))}`)
                }, _toDisplayString(getValue('team_b_fouls')), 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, "Việt vị", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_offsides'))}`)
                }, _toDisplayString(getValue('team_a_offsides')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_offsides'))}`)
                }, _toDisplayString(getValue('team_b_offsides')), 3)
              ]),
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("td", null, "xG", -1)),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_a_xg'))}`)
                }, _toDisplayString(getValue('team_a_xg')), 3),
                _createElementVNode("td", {
                  class: _normalizeClass( `as-center ${_unref(getClassForItem)(getValue('team_b_xg'))}`)
                }, _toDisplayString(getValue('team_b_xg')), 3)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _createVNode(StaticsItem, {
        title: "Trên 2.5",
        mainValue: _ctx.footyStats?.o25_potential || 0,
        subValue: _ctx.footyStats?.season_data?.seasonOver25Percentage_overall ?? 0
      }, null, 8, ["mainValue", "subValue"]),
      _createVNode(StaticsItem, {
        title: "Trên 1.5",
        mainValue: _ctx.footyStats?.o15_potential || 0,
        subValue: _ctx.footyStats?.season_data?.seasonOver15Percentage_overall ?? 0,
        classModify: "as-green"
      }, null, 8, ["mainValue", "subValue"]),
      _createVNode(StaticsItem, {
        title: "BTTS",
        mainValue: _ctx.footyStats?.btts_potential || 0,
        subValue: _ctx.footyStats?.season_data?.seasonBTTSPercentage ?? 0
      }, null, 8, ["mainValue", "subValue"]),
      _createVNode(StaticsItem, {
        title: "Bàn thắng/trận",
        mainValue: _ctx.footyStats?.avg_potential || 0,
        subValue: _ctx.footyStats?.season_data?.seasonAVG_overall ?? 0,
        classModify: "as-blue"
      }, null, 8, ["mainValue", "subValue"]),
      _createVNode(StaticsItem, {
        title: "Thẻ",
        mainValue: _ctx.footyStats?.cards_potential || 0,
        subValue: _ctx.footyStats?.season_data?.cardsAVG_overall ?? 0,
        classModify: "as-blue"
      }, null, 8, ["mainValue", "subValue"]),
      _createVNode(StaticsItem, {
        title: "Phạt góc",
        mainValue: _ctx.footyStats?.corners_potential || 0,
        subValue: _ctx.footyStats?.season_data?.cornersAVG_overall ?? 0,
        classModify: "as-blue"
      }, null, 8, ["mainValue", "subValue"])
    ])
  ]))
}
}

})